export default __webpack_public_path__ + "static/media/banner5.dc8b1e6c.jpeg";